<template>
    <div class="container">
        <div class="handle-box-search">
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

            <div class="service-box">
                <div>服务费剩余金额预警值配置</div>

                <div v-if="!edit_alert_num">
                    <span>{{ alert_num }}</span>

                    <el-button type="text" class="service-btn" @click="edit_alert_num = true">修改</el-button>
                </div>

                <div v-else>
                    <el-input v-model="alert_num" style="width: 100px"></el-input>

                    <el-button class="service-btn" @click="editAlertNumSubmit">保存</el-button>
                </div>
            </div>
            <el-button type="primary" style="margin-left: 20px" @click="recharge_num_info = true">服务费充值</el-button>
            <div class="service-box" v-if="recharge_num_info">
                <div>
                    <el-input v-model="amount" style="width: 100px;margin-right:10px"></el-input>（元）

                    <el-button class="service-btn" @click="recharge">确定</el-button>
                </div>
            </div>
        </div>
        <!-- 表格 -->
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="id" label="id" width="80"> </el-table-column>

            <el-table-column prop="city.name" label="城市名称" width="300"> </el-table-column>

            <el-table-column prop="amount" label="总金额">
              
            </el-table-column>

            <el-table-column prop="total_money" label="剩余金额" ><template slot-scope="scope">
                    <span :class="scope.row.total_money<=300?'red':''">
                        {{ scope.row.total_money }}
                    </span>
                </template> </el-table-column>
            <el-table-column prop="used_amount" label="已使用金额"> </el-table-column>

            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'danger' : 'success'"> {{ scope.row.status.alias }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="time_simple" label="创建时间">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>详细时间: {{ scope.row.time.YmdHis }}</p>
                        <div slot="reference">
                            <el-tag size="medium" style="border: 0; background-color: #fff; color: #333">{{ scope.row.time.Ymd }} </el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 充值二维码组件 -->
        <recharge :isShow="recharge_isShow" :data="amount" @onSubmit="serviceFeeLists"></recharge>
    </div>
</template>

  <script>
var _this;
import recharge from './recharge.vue';

export default {
    components: {
        recharge
    },
    data() {
        return {
            alert_num: '0',
            amount: '',
            recharge_isShow: false,
            edit_alert_num: false,
            recharge_num_info: false,

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10
            },

            result_data: [],

            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchserviceFeeLists();
    },

    methods: {
        recharge() {
            if (Number(_this.amount) >=0.01 && Number(_this.amount)<=10000) {
               
                    _this.recharge_isShow = !_this.recharge_isShow;
                    
                   
                }else{
                    _this.$message.error('服务费充值金额为大于0.01小于等于10000的数字！');
                }

          
             
            
        },
        editAlertNumSubmit() {
            _this
                .$post('/service_fee/editAlertNumSubmit', {
                    alert_num: _this.alert_num
                })
                .then((res) => {
                    _this.$message.success(res.msg);

                    _this.edit_alert_num = false;

                    _this.searchserviceFeeLists();
                })
                .catch((err) => {});
        },

        searchserviceFeeLists() {
            _this.search_data.page = 1;

            _this.serviceFeeLists();
        },

        //搜索公司列表
        serviceFeeLists() {
            console.log(_this.search_data);
            _this
                .$post('/service_fee/serviceFeeLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.result_data = res;
                    _this.tableData = res.data;
                    _this.amount = '';
                    _this.recharge_num_info = false;

                    _this.alert_num = res.data[0].alert_num || '0';
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.serviceFeeLists();
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.red {
    font-weight: 600;
    color: red;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

.service-box,
.service-box > div {
    display: inline-block;
    margin-left: 10px;
}
.service-box > div .service-btn {
    margin-left: 5px;
}
</style>
